import { useState } from "react";
import {
  Button,
  ButtonSize,
  ButtonVariant,
  Hide,
  InputSize,
  Show
} from "shared/components";
import { BaseInput } from "shared/components/forms/BaseInput";
import { FilterIcon, PlusSignIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Switch, SwitchSize } from "shared/components/forms/Switch";
import { TaskOptions } from "../constants";
import { AssigneeFilterPopover } from "shared/components/Assignee";
import { TaskDrawer } from "../slices/TaskDrawer";

export const TaskTableHeader = ({
  search,
  setSearch,
  showCompletedTasks,
  setShowCompletedTasks,
  onFiltersClick,
  selectedAssigneeIds,
  onSelectedAssigneeIdsChange,
  isCreateTaskDrawerOpen,
  setIsCreateTaskDrawerOpen,
  onCreated,
  hasHeaderTitle = false,
  hideFilters = false
}: {
  search: string;
  setSearch: (search: string) => void;
  showCompletedTasks: boolean;
  setShowCompletedTasks: (show: boolean) => void;
  onFiltersClick: () => void;
  selectedAssigneeIds: number[] | null;
  onSelectedAssigneeIdsChange: (ids: number[] | null) => void;
  isCreateTaskDrawerOpen: boolean;
  setIsCreateTaskDrawerOpen: (isOpen: boolean) => void;
  onCreated: () => void;
  hasHeaderTitle?: boolean;
  hideFilters?: boolean;
}) => {
  const [isAssigneeFilterOpen, setIsAssigneeFilterOpen] = useState(false);
  return (
    <header>
      <Show if={hasHeaderTitle}>
        <h1 className="text-2xl font-bold text-content-1000 mb-6">Tasks</h1>
      </Show>
      <div className="mb-4">
        <div className="flex flex-wrap items-center gap-2">
          <div className="w-full md:w-auto">
            <BaseInput
              id="search"
              placeholder="Search tasks"
              className="!mb-0 w-full lg:max-w-[271px] !h-10"
              size={InputSize.SM}
              value={search}
              onChange={setSearch}
            />
          </div>

          <Hide if={hideFilters}>
            <Button
              HugeIcon={FilterIcon}
              size={ButtonSize.SM}
              className="!max-w-10 w-full !items-center !justify-center !gap-0"
              onClick={onFiltersClick}
              aria-label={TaskOptions.filters}
            />
          </Hide>
          <AssigneeFilterPopover
            open={isAssigneeFilterOpen}
            onOpenChange={setIsAssigneeFilterOpen}
            selectedUserIds={selectedAssigneeIds}
            onSelectedUserIdsChange={onSelectedAssigneeIdsChange}
          />
          <div className="ml-auto hidden md:flex md:items-center md:gap-2 shrink-0 md:w-auto w-full">
            <div className="flex items-center gap-4">
              <Switch
                label="Show completed tasks"
                size={SwitchSize.SM}
                checked={showCompletedTasks}
                onChange={() => {
                  setShowCompletedTasks(!showCompletedTasks);
                }}
              />
              <Button
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.SM}
                HugeIcon={PlusSignIcon}
                className="m-auto w-[125px]"
                onClick={() => setIsCreateTaskDrawerOpen(true)}
              >
                {TaskOptions.create}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <TaskDrawer
        open={isCreateTaskDrawerOpen}
        mode="create"
        onClose={() => setIsCreateTaskDrawerOpen(false)}
        onCreated={onCreated}
      />
    </header>
  );
};
